import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

import { WidgetListItem } from './dashboard-widget.model';
import { CardHeaderComponent } from './card-header.component';

@Component({
  selector: 'app-list-tile',
  standalone: true,
  imports: [RouterLink, CardHeaderComponent],
  template: `
    <div
      class="card flex h-full flex-col gap-3 rounded-xl border border-surface-200/60 bg-surface-0 p-5 dark:border-surface-700/40 dark:bg-surface-900"
    >
      <app-card-header [title]="title()" [subtitle]="subtitle()" [icon]="icon()" [accent]="accent()">
        @if (!loading() && items().length) {
        <span
          header-actions
          class="rounded-full bg-surface-100 px-2 py-0.5 text-xs font-medium text-text-muted dark:bg-surface-800"
        >
          {{ items().length }}
        </span>
        }
      </app-card-header>

      @if (loading()) {
      <div class="flex flex-col gap-2">
        @for (i of [1, 2, 3, 4]; track i) {
        <div class="h-12 w-full animate-pulse rounded-lg bg-surface-100 dark:bg-surface-800"></div>
        }
      </div>
      } @else if (items().length) {
      <ul class="flex max-h-72 flex-col divide-y divide-surface-200/60 overflow-y-auto dark:divide-surface-700/40">
        @for (item of items(); track item.label) {
        <li>
          <a
            [routerLink]="item.link ?? '/'"
            class="group flex items-center gap-3 py-2.5 transition-colors hover:bg-surface-50 dark:hover:bg-surface-800/50"
          >
            @if (item.tag) {
            <span
              class="flex h-6 min-w-6 shrink-0 items-center justify-center rounded-md px-1.5 text-xs font-semibold"
              [class]="tagClass(item)"
              >{{ item.tag }}</span
            >
            }
            <div class="flex min-w-0 flex-col">
              <span class="truncate text-sm font-medium text-text-main">{{ item.label }}</span>
              @if (item.sublabel) {
              <span class="truncate text-xs text-text-muted">{{ item.sublabel }}</span>
              }
            </div>
            <i class="pi pi-chevron-right ml-auto text-xs text-text-muted group-hover:text-primary-500"></i>
          </a>
        </li>
        }
      </ul>
      } @else {
      <div class="flex flex-1 items-center justify-center py-8 text-sm text-text-muted">Nothing pending 🎉</div>
      }
    </div>
  `,
})
export class ListTileComponent {
  title = input.required<string>();
  subtitle = input<string>('');
  icon = input<string>('');
  accent = input<string>('');
  items = input<WidgetListItem[]>([]);
  loading = input<boolean>(false);

  /** Tag colour by urgency tone — status colour, paired with the label text. */
  tagClass(item: WidgetListItem): string {
    switch (item.tone) {
      case 'urgent':
        return 'bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-400';
      case 'info':
        return 'bg-primary-100 text-primary-700 dark:bg-primary-500/15 dark:text-primary-400';
      default:
        return 'bg-surface-100 text-text-muted dark:bg-surface-800';
    }
  }
}
